import { LogLevel, PassedInitialConfig } from "angular-auth-oidc-client";
import { environment } from "src/environments/environment";


export const authConfig: PassedInitialConfig = {
  config: {
    // Issuer info, scopes and response type
    authority: environment.authority,
    clientId: environment.clientId,
    scope: environment.scope,
    responseType: environment.responseType,
    // Debug level
    logLevel: LogLevel.Debug,
    // Redirect
    redirectUrl: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    triggerAuthorizationResultEvent: true,
    postLoginRoute: '/sync',
    // Renew token
    silentRenew: true,
    useRefreshToken: true,
    // Add Bearer token to all API calls
    secureRoutes: [ environment.apiUrl ]
  }
}
